import { useEffect, useRef, useState } from "react";
import { CreditCard, Money, Lifebuoy, ArrowClockwise } from "@phosphor-icons/react";
import { kioskApi, errText } from "@/lib/kioskApi";

const fmt = (n) => `$${Number(n || 0).toFixed(2)}`;

// Table QR online card (existing Stripe online checkout). The order reaches KDS only after Stripe confirms payment.
export function TableOnlinePay({ session, onUpdate, onHelp, cashOk }) {
  const [err, setErr] = useState("");
  const opened = useRef(false);
  const url = session.online?.checkout_url;
  useEffect(() => {
    if (url && !opened.current && !sessionStorage.getItem(`mm_qr_opened_${session.online?.session_id}`)) {
      opened.current = true;
      sessionStorage.setItem(`mm_qr_opened_${session.online?.session_id}`, "1");
      window.location.assign(url);
    }
  }, [url, session.online?.session_id]);
  useEffect(() => {
    const t = setInterval(() => kioskApi.post(`/sessions/${session.id}/online/status`).then((r) => onUpdate(r.data.session)).catch(() => {}), 3000);
    return () => clearInterval(t);
  }, [session.id, onUpdate]);
  const op = async (o) => {
    setErr("");
    try { const r = await kioskApi.post(`/sessions/${session.id}/online/${o}`, o === "retry" ? { origin_url: window.location.origin } : undefined); onUpdate(r.data.session); }
    catch (e) { setErr(errText(e)); }
  };
  return (
    <div className="fixed inset-0 z-30 bg-[#0f2a3d] flex items-center justify-center p-6 text-white overflow-y-auto" data-testid="table-online-pay">
      <div className="max-w-md w-full text-center kiosk-rise">
        <CreditCard size={56} className="mx-auto" />
        <div className="text-4xl font-bold font-heading mt-6 tabular-nums" data-testid="table-online-amount">{fmt(session.estimated_due)}</div>
        <div className="text-xl mt-3">Waiting for your online card payment. Your order goes to the kitchen as soon as it's approved.</div>
        {err && <div className="text-[#ffb59a] mt-3" data-testid="table-online-error">{err}</div>}
        <div className="grid gap-3 mt-8">
          {url && <a className="kiosk-big bg-[#e2572b] justify-center" href={url} data-testid="table-online-open"><CreditCard size={22} /> Open secure payment</a>}
          <button className="kiosk-big bg-white/10 justify-center" data-testid="table-online-retry" onClick={() => op("retry")}><ArrowClockwise size={22} /> Retry online card</button>
          {cashOk && <button className="kiosk-big bg-white !text-[#0f2a3d] justify-center" data-testid="table-online-counter" onClick={() => op("counter")}><Money size={22} /> Pay at the counter instead</button>}
          <button className="kiosk-big bg-white/10 justify-center" data-testid="table-online-help" onClick={onHelp}><Lifebuoy size={22} /> Get help</button>
        </div>
      </div>
    </div>
  );
}
